/* eslint-disable react/require-default-props */
import { useEffect, useState } from 'react';

type CallSectionTimerProps = {
  startTime?: Date | string | number;
};

const CallSectionTimer = ({ startTime }: CallSectionTimerProps) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const getElapsedSeconds = () => {
      if (!startTime) return 0;

      const start = new Date(startTime).getTime();
      const now = Date.now();
      return Math.floor((now - start) / 1000);
    };

    setElapsedSeconds(getElapsedSeconds());

    const interval = setInterval(() => {
      setElapsedSeconds(getElapsedSeconds());
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return (
    <>
      {hours > 0
        ? `${hours}:${formattedMinutes}:${formattedSeconds}`
        : `${formattedMinutes}:${formattedSeconds}`}
    </>
  );
};

export default CallSectionTimer;
